module.exports = __webpack_public_path__ + "static/media/IMG_20191127_133843.dcdd0759.jpg";